Ext.define('SA.data.mixin.ManyLocations', {
    addLocation(location) {
        location = SA.data.LocationsCache.toLocationItem(location);

        if (this.containsLocation(location)) {
            return null;
        }

        if (this.addLocationImpl(location) === false) {
            return false;
        }

        this.fireEvent('change:location', this);

        return true;
    },

    addLocationImpl(location) {
        var data = this.data;

        data.locationItems = data.locationItems.concat(location);
    },

    addLocations(locations) {
        locations.forEach(this.addLocation, this);
    },

    clearLocations() {
        this.getLocations().forEach(location => this.removeLocation(location));
    },

    containsLocation(locationSeries) {
        return this.indexOfLocation(locationSeries) !== -1;
    },

    getLocation() {
        return this.getLocations()[0];
    },

    getLocations() {
        return this.data.locationItems.map(SA.data.LocationsCache.toLocationSeries);
    },

    indexOfLocation(locationSeries) {
        locationSeries = SA.data.LocationsCache.toLocationSeries(locationSeries);

        return this.getLocations().indexOf(locationSeries);
    },

    moveLocation(oldIndex, newIndex) {
        if (typeof oldIndex !== 'number') {
            oldIndex = this.indexOfLocation(oldIndex);
        }



                newIndex = Ext.Number.constrain(newIndex, 0, this.getLocations().length - 1);

        if (oldIndex === newIndex) {
            return;
        }

        this.moveLocationImpl(oldIndex, newIndex);

        this.fireEvent('change:location');
    },

    moveLocationImpl(oldIndex, newIndex) {
        var data = this.data,
            locations = data.locationItems = data.locationItems.slice();

        locations.splice(newIndex, 0, locations.splice(oldIndex, 1)[0]);
    },

    onCustomLocationUpdate(location) {
        location = SA.data.LocationsCache.toLocationItem(location);

        if (this.containsLocation(location)) {
            this.onCustomLocationUpdateImpl(location);

            this.fireEvent('change:location', this);
        }
    },

    onCustomLocationUpdateImpl: Ext.emptyFn,

    removeLocation(location) {
        location = SA.data.LocationsCache.toLocationItem(location);

        if (this.containsLocation(location)) {
            this.removeLocationImpl(location);

            this.fireEvent('change:location', this);
        }
    },

    removeLocationImpl(location) {
        var data = this.data,
            locations = data.locationItems,
            index = this.indexOfLocation(location);

        locations = data.locationItems = locations.slice();

        locations.splice(index, 1);
    },

    setLocationsOrder(stringIds) {
        var currentStringIds = this.getLocations().map(location => SA.data.LocationsCache.toLocationSeries(location));

        if (SA.arraysEqual(stringIds, currentStringIds)) {
            return;
        }
        else if (!SA.Array.equalSets(stringIds, currentStringIds)) {
            throw new Error('Invalid locations order');
        }

        this.data.locationItems = stringIds.map(stringId => SA.data.LocationsCache.toLocationItem(stringId));

        this.fireEvent('change:location', this);
    },

    sortLocations(fn) {
        var data = this.data,
            Locations = SA.data.LocationsCache,
            sort = (a, b) => fn(Locations.toLocationSeries(a), Locations.toLocationSeries(b));

        data.locationItems = data.locationItems.slice().sort(sort);

        this.fireEvent('change:location', this);
    }
});